"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceLoginRequest = void 0;
var DeviceLoginRequest = /** @class */ (function () {
    function DeviceLoginRequest() {
        this.uuid = '';
        this.devicePwd = '';
        this.userCode = '18516500680';
        this.registrationID = '';
        this.uniqueId = '';
    }
    return DeviceLoginRequest;
}());
exports.DeviceLoginRequest = DeviceLoginRequest;
;
//# sourceMappingURL=deviceLogin.request.js.map